/** Tracks in-flight local_library_get_albums IPC — drives interactive heartbeat while grid loads. */

let pending = 0;
const listeners = new Set<() => void>();

export function getLocalLibraryAlbumsIpcPending(): number {
  return pending;
}

export function subscribeLocalLibraryAlbumsIpcPending(cb: () => void): () => void {
  listeners.add(cb);
  return () => listeners.delete(cb);
}

function notify(): void {
  listeners.forEach((cb) => cb());
}

export async function withLocalLibraryAlbumsIpcPending<T>(fn: () => Promise<T>): Promise<T> {
  pending += 1;
  notify();
  try {
    return await fn();
  } finally {
    pending = Math.max(0, pending - 1);
    notify();
  }
}
